type MessageContainer = {
  message?: unknown;
};

export type InterfaceListErrorMessageRow = {
  errorMessage?: unknown;
  information?: {
    val?: unknown;
    duplicatedIdList?: readonly MessageContainer[];
    layoutFileExistanceList?: readonly MessageContainer[];
  };
};

export const normalizeErrorMessages = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.flatMap(normalizeErrorMessages);
  }

  if (typeof value !== "string") {
    return [];
  }

  return value
    .split(/\r?\n/)
    .map((message) => message.trim())
    .filter((message) => message.length > 0);
};

type CreateErrorPanelMessagesParams = {
  row?: InterfaceListErrorMessageRow;
  frontendValidationMessages?: readonly string[];
};

export const createErrorPanelMessages = ({
  row,
  frontendValidationMessages = [],
}: CreateErrorPanelMessagesParams): string[] =>
  normalizeErrorMessages([
    frontendValidationMessages,
    row?.errorMessage,
    row?.information?.val,
    row?.information?.duplicatedIdList?.map((item) => item.message),
    row?.information?.layoutFileExistanceList?.map((item) => item.message),
  ]);
